export default __webpack_public_path__ + "static/media/firechat.e52ae57d.png";